// extracted by mini-css-extract-plugin
module.exports = {"header":"Contacts2_header__1-MQ9","divider":"Contacts2_divider__2OreI","info":"Contacts2_info__2bSbQ","wrapper":"Contacts2_wrapper__1HbJa"};